module.exports = __webpack_public_path__ + "img/vendor-profile.2937da39.jpg";